"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Forbidden = void 0;
const ResponseError_1 = require("./ResponseError");
class Forbidden extends ResponseError_1.ResponseError {
    constructor(options) {
        super(options);
        this.message = this.message || Forbidden.message;
        this.type = Forbidden.type;
        this.name = this.constructor.name;
        this.statusCode = Forbidden.statusCode;
        Error.captureStackTrace(this, Forbidden);
    }
}
exports.Forbidden = Forbidden;
Forbidden.type = 'Forbidden';
Forbidden.message = 'insufficient rights to resource';
Forbidden.statusCode = 403;
//# sourceMappingURL=Forbidden.js.map